// extracted by mini-css-extract-plugin
module.exports = {"AutosaveLoader":"AutosaveLoader_AutosaveLoader__1k094"};